import { Button, Flex, type FlexProps } from 'antd';
import type { FC } from 'react';
import { Text } from '../antd';
import { useTranslation } from 'react-i18next';

interface FetchingErrorStateProps
  extends Omit<FlexProps, 'flexDirection' | 'justifyContent' | 'alignItems' | 'children'> {
  refetch?: () => void;
  refetchButtonText?: string;
  errorMessage?: string;
}

export const FetchingErrorState: FC<FetchingErrorStateProps> = ({
  refetch,
  refetchButtonText,
  errorMessage,
  ...flexProps
}) => {
  const { t } = useTranslation('translation');
  const resolvedErrorMessage = errorMessage ?? t('common.fetchingError.message');
  const resolvedRefetchLabel = refetchButtonText ?? t('common.fetchingError.refetch');

  return (
    <Flex
      flex="1 1 0"
      style={{ padding: '20px', ...flexProps }}
      justify="center"
      align="center"
      gap={12}
      vertical
    >
      <Text variant="sm" fontWeight={500}>
        {resolvedErrorMessage}
      </Text>

      <Button onClick={refetch}>{resolvedRefetchLabel}</Button>
    </Flex>
  );
};
